module.exports = __webpack_public_path__ + "static/media/ad.2bf6b0a6.png";